const cardItems = [
  {
    title: '烧脑悬疑片单：十部反转神作',
    desc: '结局出人意料的高分悬疑电影精选，挑战你的推理能力',
    img: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20movie%20atmosphere%20with%20warm%20dramatic%20lighting%2C%20shadow%20and%20light%20contrast%2C%20detective%20noir%20aesthetic%2C%20golden%20amber%20accents%2C%20suspenseful%20composition%2C%20no%20text%2C%20cinematic%20film%20photography&width=800&height=500&seq=card-image-01&orientation=landscape',
    tag: '悬疑',
    date: '07-31',
  },
  {
    title: '周末治愈系：五部温暖心灵的电影',
    desc: '忙碌一周后的最佳放松选择，这些电影能治愈你的疲惫',
    img: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20healing%20movie%20atmosphere%20with%20soft%20sunlight%2C%20comforting%20home%20scene%2C%20gentle%20amber%20and%20golden%20tones%2C%20peaceful%20composition%2C%20no%20text%2C%20lifestyle%20cinema%20photography&width=800&height=500&seq=card-image-02&orientation=landscape',
    tag: '治愈',
    date: '07-30',
  },
  {
    title: '动作片迷必收：年度最佳打斗场面',
    desc: '肾上腺素飙升的精彩动作电影合集，每一场打斗都值得反复回味',
    img: 'https://readdy.ai/api/search-image?query=Action%20movie%20dynamic%20scene%20with%20warm%20dramatic%20lighting%2C%20intense%20combat%20silhouette%2C%20golden%20and%20coral%20color%20palette%2C%20explosive%20cinematic%20composition%2C%20no%20text%2C%20high%20energy%20film%20photography&width=800&height=500&seq=card-image-03&orientation=landscape',
    tag: '动作',
    date: '07-29',
  },
  {
    title: '深夜观影：那些让人失眠的恐怖片',
    desc: '精选近年口碑最佳的恐怖惊悚电影，胆小慎入但绝对精彩',
    img: 'https://readdy.ai/api/search-image?query=Horror%20movie%20atmosphere%20with%20dim%20warm%20lighting%2C%20eerie%20shadowy%20composition%2C%20candlelit%20dark%20room%20aesthetic%2C%20amber%20glow%20in%20darkness%2C%20no%20text%2C%20suspenseful%20cinematic%20photography&width=800&height=500&seq=card-image-04&orientation=landscape',
    tag: '恐怖',
    date: '07-28',
  },
  {
    title: '国风动画崛起：五部必看国产动画电影',
    desc: '从《大圣归来》到最新力作，国产动画电影迎来黄金时代',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20art%20style%20with%20warm%20oriental%20aesthetic%2C%20traditional%20ink%20painting%20elements%20with%20modern%20cinematic%20lighting%2C%20golden%20and%20coral%20tones%2C%20no%20text%2C%20elegant%20composition&width=800&height=500&seq=card-image-05&orientation=landscape',
    tag: '动画',
    date: '07-27',
  },
  {
    title: '科幻迷盛宴：近十年最佳科幻电影盘点',
    desc: '从硬核科幻到视觉奇观，精选影响整个时代的科幻经典之作',
    img: 'https://readdy.ai/api/search-image?query=Science%20fiction%20movie%20visual%20with%20warm%20futuristic%20lighting%2C%20space%20and%20technology%20elements%2C%20golden%20and%20amber%20nebula%20tones%2C%20epic%20cinematic%20scale%2C%20no%20text%2C%20grand%20film%20photography&width=800&height=500&seq=card-image-06&orientation=landscape',
    tag: '科幻',
    date: '07-26',
  },
  {
    title: '爱情片单：十部让人相信爱情的电影',
    desc: '从经典到现代，那些让人心动不已的浪漫爱情故事精选',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20movie%20atmosphere%20with%20warm%20golden%20sunset%20lighting%2C%20soft%20intimate%20scene%2C%20gentle%20coral%20and%20amber%20tones%2C%20dreamy%20bokeh%20effect%2C%20no%20text%2C%20romantic%20cinematic%20photography&width=800&height=500&seq=card-image-07&orientation=landscape',
    tag: '爱情',
    date: '07-25',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 mx-auto max-w-[1440px]">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-700 bg-primary-100 rounded-full mb-3">
            精选推荐
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            编辑精选片单
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            90影视团队精心筛选的高质量影视推荐，发现更多值得观看的精彩内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.slice(0, 6).map((item, i) => (
            <a key={i} href="#carousel" className="group block bg-background-50 rounded-xl border border-background-200/60 overflow-hidden hover:border-accent-300/50 transition-all duration-300 no-underline">
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500/90 text-background-50 text-xs font-medium rounded-md">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1.5 group-hover:text-accent-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-2">
                  {item.desc}
                </p>
                <span className="text-xs text-foreground-400">{item.date}</span>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-5">
          <a href="#carousel" className="group block bg-background-50 rounded-xl border border-background-200/60 overflow-hidden hover:border-accent-300/50 transition-all duration-300 no-underline">
            <div className="flex flex-col sm:flex-row">
              <div className="relative sm:w-2/5 lg:w-1/3 aspect-[16/10] sm:aspect-auto overflow-hidden bg-background-200 shrink-0">
                <img
                  src={cardItems[6].img}
                  alt={cardItems[6].title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500/90 text-background-50 text-xs font-medium rounded-md">
                  {cardItems[6].tag}
                </span>
              </div>
              <div className="p-5 flex flex-col justify-center">
                <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2 group-hover:text-accent-600 transition-colors">
                  {cardItems[6].title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-2">
                  {cardItems[6].desc}
                </p>
                <span className="text-xs text-foreground-400">{cardItems[6].date}</span>
              </div>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}